import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../utils/supabaseClient.js';
import SEO from './SEO.js';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const CategoryIndex = () => {
  const [categories, setCategories] = useState([]);
  const [brands, setBrands] = useState([]); // NEW STATE
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        // 1. Fetch Categories, BRANDS, Tags, and Banned List
        const [catRes, brandRes, tagRes, ignoredRes] = await Promise.all([
          supabase.rpc('get_unique_categories'),
          supabase.rpc('get_unique_brands'), // Call new SQL function
          supabase.rpc('get_unique_tags'),
          supabase.from('ignored_tags').select('tag')
        ]);

        if (catRes.error) console.error('Cat Error:', catRes.error);
        if (brandRes.error) console.error('Brand Error:', brandRes.error);

        // 2. Process Data
        const bannedSet = new Set((ignoredRes.data || []).map(i => i.tag.toLowerCase()));

        const cleanCats = (catRes.data || []).map(c => c.category).filter(c => c && c !== 'Uncategorized');
        const cleanBrands = (brandRes.data || []).map(b => b.brand); // Extract brands
        
        const cleanTags = (tagRes.data || [])
          .map(t => t.tag)
          .filter(t => t && !bannedSet.has(t.toLowerCase()))
          .slice(0, 20);

        setCategories(cleanCats);
        setBrands(cleanBrands);
        setTags(cleanTags);

      } catch (error) {
        console.error('Unexpected error:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="container mt-5">
      <SEO title="Browse Catalog" description="Browse products by category, brand, or tag." />
      
      <div className="row">
        {/* --- 1. CATEGORIES --- */}
        <div className="col-12 mb-5">
          <h2 className="mb-4 pb-2 border-bottom">Browse by Category</h2>
          {loading ? <Skeleton count={2} height={40} /> : (
            <div className="d-flex flex-wrap gap-3">
              {categories.map((cat) => (
                <Link key={cat} to={`/category/${encodeURIComponent(cat)}`} className="btn btn-outline-primary btn-lg">
                  {cat}
                </Link>
              ))}
              {categories.length === 0 && <p className="text-muted">No categories found.</p>}
            </div>
          )}
        </div>

        {/* --- 2. BRANDS (NEW SECTION) --- */}
        <div className="col-12 mb-5">
          <h2 className="mb-4 pb-2 border-bottom">Browse by Brand</h2>
          {loading ? <Skeleton count={2} height={40} /> : (
            <div className="d-flex flex-wrap gap-3">
              {brands.map((brand) => (
                <Link key={brand} to={`/brand/${encodeURIComponent(brand)}`} className="btn btn-secondary ">
                  {brand}
                </Link>
              ))}
              {brands.length === 0 && <p className="text-muted">No brands assigned yet.</p>}
            </div>
          )}
        </div>

        {/* --- 3. TAGS --- */}
        <div className="col-12">
          <h2 className="mb-4 pb-2 border-bottom">Popular Keywords</h2>
          {loading ? <Skeleton count={2} /> : (
            <div className="d-flex flex-wrap gap-2">
              {tags.map((tag) => (
                <Link key={tag} to={`/tag/${encodeURIComponent(tag)}`} className="badge bg-light text-dark text-decoration-none border p-3" style={{ fontSize: '1rem' }}>
                  #{tag}
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CategoryIndex;